<h2 mat-dialog-title>{{data.fileName}}</h2>

<mat-dialog-content class="overflow-auto"  >
    <div class="border border-solid rounded pb-4">
        <pdf-viewer 
          *ngIf="data.isPdfFile"
          [src]="src"
          [rotation]="0"
          [original-size]="false"
          [show-all]="true"
          [fit-to-page]="false"
          [zoom]="1"
          [zoom-scale]="'page-width'"
          [stick-to-page]="false"
          [render-text]="false"
          [external-link-target]="'blank'"
          [autoresize]="true"
          style="width: 98%; height: 60vh; margin:auto; overflow-x: hidden;"
        ></pdf-viewer>

        <img class="w-full" [src]="src" alt="preview" *ngIf="data.isImgFile"/>

        <div class="flex items-center justify-center w-full" *ngIf="data.isOtherTypeFile">
            <div class="relative">
                <div
                    class="absolute left-0 bottom-0 px-1.5 rounded text-sm font-semibold leading-5 text-white bg-black">
                    File
                </div>
            </div>
        </div>
      </div>
      
      <div class="border border-solid rounded h-100 flex text-center items-center" *ngIf="isLoading">
        <mat-spinner class="flex text-center items-center m-auto" [mode]="'indeterminate'" diameter="40"></mat-spinner>
      </div>
</mat-dialog-content>

<mat-dialog-actions class="flex justify-end">
    <button mat-raised-button [mat-dialog-close]="true" mat-dialog-close >Fermer</button>
    <button mat-raised-button class="bg-accent text-white" (click)="clickDownloadFile()">Télécharger</button>
</mat-dialog-actions>